import { Action } from "@ngrx/store";



//Variaveis dos Cards
export interface AdministratorModeStateModel {
    isAdmin: boolean,
    menuItems: any
}

export enum AdministratorModeActionTypes {

    LOAD_MENU_ADMIN = "[Administrator Mode] LOAD_MENU_ADMIN Administrator Mode",
    LOAD_MENU_ADMIN_SUCCESS = "[Administrator Mode] LOAD_MENU_ADMIN_SUCCESS Administrator Mode",
    LOAD_MENU_ADMIN_FAILURE = "[Administrator Mode] LOAD_MENU_ADMIN_FAILURE Administrator Mode",

    LOAD_MENU_REGULAR = "[Administrator Mode] LOAD_MENU_REGULAR Administrator Mode",
    LOAD_MENU_REGULAR_SUCCESS = "[Administrator Mode] LOAD_MENU_REGULAR_SUCCESS Administrator Mode",
    LOAD_MENU_REGULAR_FAILURE = "[Administrator Mode] LOAD_MENU_REGULAR_FAILURE Administrator Mode",

    DELETE_MENU = "[Administrator Mode] DELETE_MENU"

}

export class LoadMenuAdmin implements Action {

    readonly type = AdministratorModeActionTypes.LOAD_MENU_ADMIN;

    constructor() { }
}
export class LoadMenuAdminSuccess implements Action {

    readonly type = AdministratorModeActionTypes.LOAD_MENU_ADMIN_SUCCESS;

    constructor(public menuItems: any) { }
}

export class LoadMenuAdminFailure implements Action {

    readonly type = AdministratorModeActionTypes.LOAD_MENU_ADMIN_FAILURE;

    constructor() { }
}

export class LoadMenuRegular implements Action {

    readonly type = AdministratorModeActionTypes.LOAD_MENU_REGULAR;

    constructor() { }
}
export class LoadMenuRegularSuccess implements Action {

    readonly type = AdministratorModeActionTypes.LOAD_MENU_REGULAR_SUCCESS;

    constructor(public menuItems: any) { }
}

export class LoadMenuRegularFailure implements Action {

    readonly type = AdministratorModeActionTypes.LOAD_MENU_REGULAR_FAILURE;

    constructor() { }
}

export class DeleteMenu implements Action {

  readonly type = AdministratorModeActionTypes.DELETE_MENU;

  constructor() { }
}

export type AdministratorModeActionsUnion =

    | LoadMenuAdmin
    | LoadMenuAdminSuccess
    | LoadMenuAdminFailure

    | LoadMenuRegular
    | LoadMenuRegularSuccess
    | LoadMenuRegularFailure

    | DeleteMenu

    ;

